import { Link } from "react-router-dom";
import { BUSINESS, LEGAL_LINKS, NAV_LINKS, WHATSAPP_URL } from "@/lib/constants";
import { track, EVENTS } from "@/lib/analytics";

export const Footer = () => {
  return (
    <footer id="site-footer" className="bg-spice-green-deep text-spice-sage text-xs py-14 px-4 sm:px-6 border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
        <div className="space-y-3">
          <div className="inline-block bg-[#FAF8F2] rounded-md px-3 py-2">
            <img
              src={BUSINESS.logo}
              alt={`${BUSINESS.name} — ${BUSINESS.tagline}`}
              data-testid="footer-logo-image"
              width="1600"
              height="582"
              loading="lazy"
              className="w-[190px] h-[69px] object-contain mix-blend-multiply"
            />
          </div>
          <p className="text-[11px] leading-relaxed text-[#8C9E93]">
            Sole Proprietorship • Wholesale trader and distributor of green cardamom, black pepper and selected whole spices, Hyderabad.
          </p>
          <div className="text-[11px] text-spice-gold font-medium pt-1">{BUSINESS.tagline}</div>
        </div>

        <div className="space-y-2">
          <span className="text-xs font-bold uppercase tracking-wider text-white block">Enterprise Details</span>
          <div className="space-y-1 text-[11px]">
            <div>Proprietor: <span className="text-white" data-testid="footer-proprietor">{BUSINESS.proprietor}</span></div>
            <div>GSTIN: <span className="text-white" data-testid="footer-gstin">{BUSINESS.gstin}</span></div>
            <div>FSSAI: <span className="text-white">{BUSINESS.fssai}</span></div>
            <div>Udyam: <span className="text-white">{BUSINESS.udyam}</span></div>
          </div>
        </div>

        <div className="space-y-2">
          <span className="text-xs font-bold uppercase tracking-wider text-white block">Contact</span>
          <div className="space-y-1 text-[11px]">
            <div data-testid="footer-address">{BUSINESS.address}</div>
            <div>
              Phone / WhatsApp:{" "}
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Message Nandanaaya Spices on WhatsApp (opens in a new tab)"
                onClick={() => track(EVENTS.whatsappClick, { source: "footer" })}
                className="text-white hover:text-spice-gold transition-colors"
                data-testid="footer-phone"
              >
                {BUSINESS.phoneDisplay}
              </a>
            </div>
            <div>
              Email:{" "}
              <a
                href={`mailto:${BUSINESS.email}`}
                onClick={() => track(EVENTS.emailClick, { source: "footer" })}
                className="text-white hover:text-spice-gold transition-colors break-all"
                data-testid="footer-email"
              >
                {BUSINESS.email}
              </a>
            </div>
            <div>Working Hours: {BUSINESS.hours}</div>
          </div>
        </div>

        <div className="space-y-4">
          <div className="space-y-2">
            <span className="text-xs font-bold uppercase tracking-wider text-white block">Navigate</span>
            <div className="flex flex-col space-y-1.5 text-[11px]">
              {NAV_LINKS.filter((l) => l.to !== "/").map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="hover:text-white transition-colors"
                  data-testid={`footer-link-${link.testid}`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
          <div className="space-y-2">
            <span className="text-xs font-bold uppercase tracking-wider text-white block">Policies</span>
            <div className="flex flex-col space-y-1.5 text-[11px]">
              {LEGAL_LINKS.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="hover:text-white transition-colors"
                  data-testid={`footer-legal-${link.to.replace("/", "")}`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-[11px] text-spice-subtle">
        <div>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</div>
        <div className="text-center sm:text-right" data-testid="footer-disclaimer">
          Prices, grades and stock availability are confirmed against the current lot and written quotation.
        </div>
      </div>
    </footer>
  );
};
